// @flow
const mapProductTypeForURL = (productType: string): string => {
  switch (productType) {
    case 'electricity':
      return 'Sähkö'
    case 'heat':
      return 'Lämpö'
    case 'water':
      return 'Vesi'
    case 'fiber':
      return 'Valokuitu'
    default:
      return ''
  }
}
export default mapProductTypeForURL
